import { DataTablePaginate } from '@/common/ui/table/data-table-paginate'
import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { DataTableSimpleSearch } from '@/common/ui/table/data-table-simple-search'
import { DataTableFilterSelector } from '@/common/ui/table/data-table-selector-with-query'
import { columns, writeAccessorKeys } from './constants'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useMemo } from 'react'
import { EVENT_TYPE_OPTIONS, EVENT_STATUS_OPTIONS } from '../../constants'
import type { UnifiedEventData } from '@/modules/events/type'

interface EventTableProps {
	data: UnifiedEventData[]
	total: number
	isLoading?: boolean
}

export default function EventTable({
	data,
	total,
	isLoading,
}: EventTableProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.WEB_SETTING,
	)

	const filteredColumns = useMemo(
		() =>
			columns.filter(
				(column) =>
					hasWritePermission ||
					('accessorKey' in column &&
						!writeAccessorKeys.includes(column.accessorKey)),
			),
		[hasWritePermission],
	)

	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<DataTableSimpleSearch placeHolder="ค้นหาชื่อกิจกรรม..." />
				<DataTableFilterSelector
					options={EVENT_TYPE_OPTIONS}
					placeholder="ประเภทกิจกรรม"
					filterKey="type"
					className="w-48"
				/>
				<DataTableFilterSelector
					options={EVENT_STATUS_OPTIONS}
					placeholder="สถานะ"
					filterKey="status"
					className="w-48"
				/>
				<DataTableResetFilter />
			</div>
			<DataTablePaginate
				columns={filteredColumns}
				data={data}
				totalItems={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
